import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { TextKeywordsListPage } from '@/features/text-keywords';
import { formatDocumentTitle } from '@/lib/document-title';

/** Marketing › Text Keywords — "Text VIP to (714) 555-0123": every keyword, where it sends people and what they did. */
export const Route = createFileRoute('/_auth/$orgId/marketing/text-keywords')({
  component: TextKeywordsRoute,
});

function TextKeywordsRoute() {
  const { orgId } = Route.useParams();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Text Keywords', 'Marketing')}</title>
      </Helmet>
      <TextKeywordsListPage routeOrgId={orgId} />
    </>
  );
}
